let urlToPreload,mouseoverTimer,lastTouchTimestamp;const prefetcher=document.createElement("link"),isSupported=prefetcher.relList&&prefetcher.relList.supports&&prefetcher.relList.supports("prefetch"),isDataSaverEnabled=navigator.connection&&navigator.connection.saveData,allowQueryString="instantAllowQueryString"in document.body.dataset,allowExternalLinks="instantAllowExternalLinks"in document.body.dataset;if(isSupported&&!isDataSaverEnabled){prefetcher.rel="prefetch",document.head.appendChild(prefetcher);const e={capture:!0,passive:!0};document.addEventListener("touchstart",touchstartListener,e),document.addEventListener("mouseover",mouseoverListener,e)}function touchstartListener(e){lastTouchTimestamp=performance.now();const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("touchcancel",touchendAndTouchcancelListener,{passive:!0}),t.addEventListener("touchend",touchendAndTouchcancelListener,{passive:!0}),urlToPreload=t.href,preload(t.href))}function touchendAndTouchcancelListener(){urlToPreload=void 0,stopPreloading()}function mouseoverListener(e){if(performance.now()-lastTouchTimestamp<1100)return;const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("mouseout",mouseoutListener,{passive:!0}),urlToPreload=t.href,mouseoverTimer=setTimeout(()=>{preload(t.href),mouseoverTimer=void 0},65))}function mouseoutListener(e){e.relatedTarget&&e.target.closest("a")==e.relatedTarget.closest("a")||(mouseoverTimer?(clearTimeout(mouseoverTimer),mouseoverTimer=void 0):(urlToPreload=void 0,stopPreloading()))}function isPreloadable(e){if(!e||!e.href)return;if(urlToPreload==e.href)return;const t=new URL(e.href);return!(!(allowExternalLinks||t.origin==location.origin||"instant"in e.dataset)||!["http:","https:"].includes(t.protocol)||"http:"==t.protocol&&"https:"==location.protocol||!(allowQueryString||!t.search||"instant"in e.dataset)||t.hash&&t.pathname+t.search==location.pathname+location.search||"noInstant"in e.dataset)||void 0}function preload(e){prefetcher.href=e}function stopPreloading(){prefetcher.removeAttribute("href")}
;(function(){function init(){var root=document.getElementById("hexled-lumens-calc");if(!root)return;var queued=false;function clean(){queued=false;var result=root.querySelector("#hlc-result");if(!result||result.getAttribute("data-stale")!=="true"&&getComputedStyle(result).display!=="none")return;result.querySelectorAll('a[href*="/products/"]').forEach(function(a){var raw=a.getAttribute("href")||"",u=new URL(raw,location.origin);u.searchParams.delete("source");u.searchParams.delete("calculation");var href=u.pathname+u.search+u.hash;if(raw!==href)a.setAttribute("href",href)})}function queue(){if(queued)return;queued=true;setTimeout(clean,0)}root.addEventListener("input",queue,true);root.addEventListener("change",queue,true);root.addEventListener("click",queue,true);new MutationObserver(queue).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:["href","style"]});queue()}if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init()})();
;(function(){
"use strict";
var HANG_ID="hexled-hanging-install";
var PLAN_ID="hexled-lumens-planner";
var STYLE_ID="hexled-product-layout-style";
var CORE_TEMPLATE_IDS=["standard-hex-lights","large-hex","dimmable-hex","rgb-hex","signature-lights",
"22491468464313",
"22491468791993",
"22491468562617",
"22491468759225",
"22491468726457",
"22541066731705",
"22541067059385",
"22541066830009",
"22541067026617",
"22541066993849",
"22549656895673",
"22549657223353",
"22549656993977",
"22549657190585",
"22549657157817"
];
var HANGING_TEMPLATE_IDS=["standard-hex-lights","large-hex","dimmable-hex",
"22491468464313",
"22491468791993",
"22491468562617",
"22541066731705",
"22541067059385",
"22541066830009",
"22549656895673",
"22549657223353",
"22549656993977"
];
function make(tag,className,text){
var node=document.createElement(tag);
if(className)node.className=className;
if(text!==undefined)node.textContent=text;
return node
}
function mainSection(){
return document.querySelector('#MainContent > .shopify-section[id$="__main"]')
}
function templateId(section){
var host=section&&section.querySelector("[data-template-suffix]");var suffix=host?(host.getAttribute("data-template-suffix")||"").trim():"";if(suffix)return suffix;var match=section&&section.id.match(/template--(\d+)__main$/);
return match?match[1]:""
}
function coreContext(){
if(!document.body.classList.contains("template-product"))return null;
var section=mainSection(),id=templateId(section);
if(!section||CORE_TEMPLATE_IDS.indexOf(id)===-1)return null;
var meta=section.querySelector(".product-single__meta");
var add=meta&&meta.querySelector('button[name="add"]');
var buy=add&&add.closest(".product-block");
var sub=section.nextElementSibling;
var validSub=!!(sub&&(sub.id&&sub.id.slice(-5)==="__sub"||sub.classList&&sub.classList.contains("product-full-width")));
if(!meta||!buy||!validSub)return null;
return{templateId:id,mainSection:section,meta:meta,buy:buy,sub:sub}
}
function removeDynamicEntry(){
var entry=document.getElementById("hexled-lumens-entry");
var planner=document.getElementById(PLAN_ID);
if(planner)planner.remove();
else if(entry)entry.remove()
}
function reviewLabel(){
var label=document.getElementById("hx-review-scope-top");
if(label&&label.textContent!=="Verified reviews by Judge.me")label.textContent="Verified reviews by Judge.me"
}
function styles(){
if(document.getElementById(STYLE_ID))return;
var style=document.createElement("style");
style.id=STYLE_ID;
style.textContent=[
"#hexled-hanging-install{box-sizing:border-box;width:100%;margin:16px 0 14px;padding:18px;border:1px solid rgba(255,255,255,.12);border-radius:8px;background:linear-gradient(135deg,#111820,#0b0e12);color:#fff}",
"#hexled-hanging-install .hx-layout-kicker,#hexled-lumens-planner .hx-layout-kicker{margin:0 0 5px;color:#7aaef5;font-size:10px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase}",
"#hexled-hanging-install .hx-layout-title{margin:0 0 7px;color:#fff;font-family:Oswald,sans-serif;font-size:21px;font-weight:400;line-height:1.25;text-transform:uppercase}",
"#hexled-hanging-install .hx-layout-copy{margin:0;color:rgba(255,255,255,.68);font-size:13px;line-height:1.5}",
"#hexled-hanging-install #hx-wire-row{display:flex!important;flex-wrap:wrap!important;align-items:center!important;gap:10px!important;margin:14px 0 0!important;padding:0!important;border:0!important;background:transparent!important}",
"#hexled-hanging-install #hx-wire-row>a{flex:0 0 auto}",
"#hexled-hanging-install #hx-wire-row>a img{width:62px!important;height:62px!important}",
"#hexled-hanging-install #hx-wire-row>.hx-actions{box-sizing:border-box!important;width:100%!important;display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;gap:7px 8px!important;align-items:end!important}",
"#hexled-hanging-install .hx-wire-label{grid-column:1/-1;color:rgba(255,255,255,.72);font-size:11px;line-height:1.2}",
"#hexled-hanging-install #hx-wire-len{box-sizing:border-box!important;width:100%!important;min-width:0!important;min-height:44px!important}",
"#hexled-hanging-install #hx-wire-add{min-height:44px!important;padding:9px 13px!important;white-space:nowrap!important}",
"#hexled-hanging-install #hx-wire-info{color:rgba(255,255,255,.64)!important;line-height:1.45!important}",
"#hexled-lumens-planner{box-sizing:border-box;width:100%;padding:28px 20px 8px}",
"#hexled-lumens-planner .hx-lumens-planner-inner{box-sizing:border-box;max-width:1200px;margin:0 auto;padding:24px 26px;border:1px solid rgba(47,129,247,.42);border-radius:10px;background:linear-gradient(135deg,#111820,#0b0e12);color:#fff}",
"#hexled-lumens-planner #hexled-lumens-entry{box-sizing:border-box!important;width:100%!important;margin:0!important;padding:0!important;display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;align-items:center!important;gap:14px 24px!important;border:0!important;background:transparent!important}",
"#hexled-lumens-planner #hexled-lumens-entry>div{width:100%}",
"#hexled-lumens-planner #hexled-lumens-entry h2{margin:0 0 6px!important;color:#fff!important;font-size:24px!important;line-height:1.25!important}",
"#hexled-lumens-planner #hexled-lumens-entry p{margin:0!important;color:rgba(255,255,255,.68)!important;font-size:14px!important;line-height:1.5!important}",
"#hexled-lumens-planner #hexled-lumens-entry a{box-sizing:border-box!important;display:inline-flex!important;width:auto!important;margin:0!important;padding:12px 18px!important;border:1px solid #2f81f7!important;border-radius:4px!important;background:transparent!important;color:#8bbcff!important;font-size:14px!important;font-weight:600!important;text-decoration:none!important;white-space:nowrap!important}",
"#hexled-lumens-planner #hexled-lumens-entry a:hover{background:rgba(47,129,247,.12)!important;color:#fff!important}",
"#hexled-hanging-install button:focus-visible,#hexled-hanging-install select:focus-visible,#hexled-hanging-install a:focus-visible,#hexled-lumens-planner a:focus-visible{outline:2px solid #7aaef5;outline-offset:3px}",
"#hexled-delivery-estimate{box-sizing:border-box;width:100%;margin:18px 0 20px;padding:18px 0 0;border-top:1px solid rgba(255,255,255,.1);color:#fff}",
"#hexled-delivery-estimate ~ .product-block .trust-icons-grid{border-top:0!important;padding-top:0!important}",
"#hexled-delivery-estimate .hx-layout-kicker{margin:0 0 5px;color:#7aaef5;font-size:10px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase}",
"#hexled-delivery-estimate .hx-deliv-range{margin:0 0 14px;font-size:19px;line-height:1.3;color:rgba(255,255,255,.86)}",
"#hexled-delivery-estimate .hx-deliv-range span{color:#fff}",
"#hexled-delivery-estimate .hx-deliv-track{display:flex;align-items:center;gap:0}",
"#hexled-delivery-estimate .hx-dot{flex:0 0 auto;width:7px;height:7px;border-radius:50%;background:rgba(255,255,255,.5);font-style:normal}",
"#hexled-delivery-estimate .hx-band{flex:5 1 0;height:3px;border-radius:2px;background:#7aaef5;font-style:normal}",
"#hexled-delivery-estimate .hx-seg{flex:11 1 0;height:1px;background:rgba(255,255,255,.22);font-style:normal}",
"#hexled-delivery-estimate .hx-deliv-labels .hx-l-band{flex:5 1 0;text-align:center;color:#9cc4f7}",
"#hexled-delivery-estimate .hx-deliv-labels{display:flex;margin-top:8px}",
"#hexled-delivery-estimate .hx-deliv-labels .hx-l-start{flex:11 1 0}",
"#hexled-delivery-estimate .hx-deliv-labels span{font-size:11px;color:rgba(255,255,255,.7)}",
"@media(max-width:749px){#hexled-delivery-estimate{margin:14px 0 18px;padding-top:15px}#hexled-delivery-estimate .hx-deliv-range{font-size:17px}}",
"@media(max-width:749px){#hexled-hanging-install{padding:17px 15px}#hexled-hanging-install #hx-wire-row>.hx-actions{grid-template-columns:1fr!important}#hexled-hanging-install .hx-wire-label{grid-column:1!important;text-align:left!important;letter-spacing:.3px!important}#hexled-hanging-install #hx-wire-len{width:100%!important}#hexled-hanging-install #hx-wire-add{grid-column:1!important;width:100%!important}#hexled-lumens-planner{padding:20px 15px 4px}#hexled-lumens-planner .hx-lumens-planner-inner{padding:20px 16px}#hexled-lumens-planner #hexled-lumens-entry{display:flex!important;flex-direction:column!important;align-items:flex-start!important;gap:0!important}#hexled-lumens-planner #hexled-lumens-entry h2{font-size:21px!important}#hexled-lumens-planner #hexled-lumens-entry a{margin-top:15px!important}body.template-product.hx-hanging-visible #hexled-sticky-atc{display:none!important}}"
].join("");
document.head.appendChild(style)
}
function money(value){
return"$"+Number(value).toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2})
}
function wireQuantity(info){
var match=(info.textContent||"").match(/needs\s+(\d+)/i);
return match?parseInt(match[1],10):0
}
function prepareWire(row){
var info=row.querySelector("#hx-wire-info")||document.getElementById("hx-wire-info");
var select=row.querySelector("#hx-wire-len")||document.getElementById("hx-wire-len");
var button=row.querySelector("#hx-wire-add")||document.getElementById("hx-wire-add");
var actions=row.querySelector(".hx-actions");
var quantity=wireQuantity(info);
if(!info||!select||!button||!actions||!quantity)return false;
var hasPrice=Array.from(select.options).some(function(option){return/\$[\d.]+/.test(option.textContent||"")});
if(!hasPrice)return false;
if(!document.getElementById("hx-wire-label")){
var label=make("label","hx-wire-label","Wire length");
label.id="hx-wire-label";
label.setAttribute("for","hx-wire-len");
actions.insertBefore(label,select)
}
function sync(){
var qty=wireQuantity(info);
if(!qty)return;
Array.from(select.options).forEach(function(option){
var original=option.getAttribute("data-hx-original")||option.textContent.trim();
if(!option.hasAttribute("data-hx-original"))option.setAttribute("data-hx-original",original);
var priceMatch=original.match(/\$([\d.]+)/);
var unit=priceMatch?parseFloat(priceMatch[1]):0;
var length=original.replace(/\s*-\s*\$[\d.]+.*$/i,"").trim().replace(/(\d)(ft)/i,"$1 ft");
if(unit){
option.setAttribute("data-hx-unit",String(unit));
option.textContent=length+" — "+money(unit*qty)+" total / "+qty+" wires"
}
});
var selected=select.options[select.selectedIndex];
var unit=parseFloat(selected&&selected.getAttribute("data-hx-unit"))||0;
var total=unit*qty;
if(total){
info.textContent="This kit needs "+qty+" suspension wires · "+money(total);
if(button.textContent.trim()==="ADD"||button.textContent.indexOf("Add ")===0)button.textContent="Add "+qty+" wires · "+money(total);
button.setAttribute("aria-label","Add "+qty+" suspension wires for "+money(total))
}
}
if(!select.hasAttribute("data-hx-layout-ready")){
select.setAttribute("data-hx-layout-ready","true");
select.addEventListener("change",function(){window.setTimeout(sync,0)});
button.addEventListener("click",function(){window.setTimeout(sync,1800)})
}
sync();
return true
}
function keepSellingPointsBeforeBuy(meta,buy){
Array.from(meta.querySelectorAll(".product-block--sales-point")).forEach(function(point){
buy.parentNode.insertBefore(point,buy)
})
}
function blocksHolder(context){
return context.meta.querySelector("[data-product-blocks]")
}
function buyContainer(context){
var holder=blocksHolder(context);
if(!holder)return context.buy;
var node=context.buy;
while(node&&node.parentElement&&node.parentElement!==holder)node=node.parentElement;
return node&&node.parentElement===holder?node:context.buy
}
function hangingAnchor(context,hanging){
var start=buyContainer(context);
var node=start.nextElementSibling;
while(node&&(node===hanging||!(node.classList&&node.classList.contains("product-block"))||!(node.innerText||"").trim()))node=node.nextElementSibling;
return node||start
}
function positionHanging(context,hanging){
var anchor=hangingAnchor(context,hanging);
if(hanging.previousElementSibling!==anchor)anchor.insertAdjacentElement("afterend",hanging)
}
function stickyVisibility(card){
if(!("IntersectionObserver"in window)||card.hasAttribute("data-hx-sticky-observed"))return;
card.setAttribute("data-hx-sticky-observed","true");
var observer=new IntersectionObserver(function(entries){
entries.forEach(function(entry){
document.body.classList.toggle("hx-hanging-visible",entry.isIntersecting)
})
},{threshold:.05});
observer.observe(card)
}
function ensurePlanner(context){
var entry=document.getElementById("hexled-lumens-entry");
if(!entry)return false;
var title=entry.querySelector("h2"),copy=entry.querySelector("p"),link=entry.querySelector("a");
if(!title||!copy||!link)return false;
title.textContent="Is this kit bright enough for your room?";
copy.textContent="Use our 30-second lumen calculator to check this kit against your room size and intended use.";
link.textContent="Check my room →";
var planner=document.getElementById(PLAN_ID);
if(!planner){
planner=make("section","hx-lumens-planner");
planner.id=PLAN_ID;
var inner=make("div","hx-lumens-planner-inner");
inner.appendChild(make("p","hx-layout-kicker","Free lighting check"));
inner.appendChild(entry);
planner.appendChild(inner)
}else if(!planner.contains(entry)){
var existingInner=planner.querySelector(".hx-lumens-planner-inner");
if(!existingInner)return false;
existingInner.appendChild(entry)
}
if(planner.previousElementSibling!==context.sub)context.sub.insertAdjacentElement("afterend",planner);
return true
}
function removeEmptySource(source,context){
if(!source||source===context.mainSection||source===context.sub||source.contains(context.meta))return;
var hasControls=source.querySelector("img,button,a,input,select,textarea,video,iframe");
if(!(source.textContent||"").trim()&&!hasControls)source.remove()
}
function retireSetupSection(source,context,hanging){
if(!source||source===context.mainSection||source===context.sub||source.contains(context.meta))return;
if(hanging&&source.contains(hanging))return;
var visible=Array.from(source.querySelectorAll("img,button,a,input,select,textarea,video,iframe")).some(function(el){return el.getClientRects().length>0});
if(visible)return;
Array.from(source.querySelectorAll("h1,h2,h3,h4,h5,h6,p,span,div")).forEach(function(node){
if(node.children.length===0&&(node.textContent||"").trim().toUpperCase()==="COMPLETE YOUR SETUP")node.remove()
});
source.style.display="none"
}
function cleanOldSetup(context,row){
var tube=document.getElementById("hx-tube-row");
var old=document.getElementById("hexled-product-assist");
var source=(row||tube||old)&&((row||tube||old).closest(".shopify-section"));
if(!source){
var strayRow=document.getElementById("hx-wire-row");
if(strayRow)source=strayRow.closest(".shopify-section")
}
if(tube)tube.remove();
if(old&&!old.contains(row))old.remove();
retireSetupSection(source,context,null);
removeEmptySource(source,context)
}
function ensureHanging(context){
var hanging=document.getElementById(HANG_ID);
var rows=Array.from(document.querySelectorAll("#hx-wire-row"));
var row=rows.find(function(candidate){return!hanging||!hanging.contains(candidate)})||rows[0]||null;
if(HANGING_TEMPLATE_IDS.indexOf(context.templateId)===-1){
cleanOldSetup(context,null);
return"absent"
}
if(!row)return"pending";
var info=row.querySelector("#hx-wire-info")||document.getElementById("hx-wire-info");
if(!info||!wireQuantity(info))return"pending";
if(!prepareWire(row))return"pending";
var source=row.closest(".shopify-section");
if(!hanging){
hanging=make("section","hx-hanging-install");
hanging.id=HANG_ID;
hanging.setAttribute("aria-labelledby",HANG_ID+"-title");
hanging.appendChild(make("p","hx-layout-kicker","Optional installation"));
var title=make("h3","hx-layout-title","Hanging installation");
title.id=HANG_ID+"-title";
hanging.appendChild(title);
hanging.appendChild(make("p","hx-layout-copy","For exposed beams or suspended mounting. Direct ceiling mounting hardware is already included."));
}
positionHanging(context,hanging);
var previousRow=hanging.querySelector("#hx-wire-row");
if(previousRow&&previousRow!==row)previousRow.remove();
if(!hanging.contains(row))hanging.appendChild(row);
var tube=document.getElementById("hx-tube-row");
if(tube)tube.remove();
var old=document.getElementById("hexled-product-assist");
if(old)old.remove();
retireSetupSection(source,context,hanging);
removeEmptySource(source,context);
stickyVisibility(hanging);
return"ready"
}
function deliveryWindow(){var now=new Date();var mk=function(days){return new Date(now.getTime()+days*86400000)};var fmt=function(d){return d.toLocaleDateString("en-US",{month:"short",day:"numeric"})};return{lo:fmt(mk(11)),hi:fmt(mk(16))}}
function ensureDelivery(context){if(document.getElementById("hexled-delivery-estimate"))return;var w=deliveryWindow();var box=make("section","hx-delivery");box.id="hexled-delivery-estimate";box.setAttribute("aria-label","Estimated delivery");box.innerHTML='<p class="hx-layout-kicker">Estimated delivery</p><p class="hx-deliv-range">Order today, arrives <span>'+w.lo+'</span> to <span>'+w.hi+'</span></p><div class="hx-deliv-track"><i class="hx-dot"></i><i class="hx-seg"></i><i class="hx-band"></i></div><div class="hx-deliv-labels"><span class="hx-l-start">Today</span><span class="hx-l-band">Arrives</span></div>';var buy=buyContainer(context);var anchor=hangingAnchor(context,document.getElementById("hexled-hanging-install"));if(anchor&&anchor!==buy)anchor.insertAdjacentElement("beforebegin",box);else if(buy)buy.insertAdjacentElement("afterend",box)}
function movePaymentTerms(context){var terms=document.querySelector(".shopify-payment-terms");var price=context.meta.querySelector(".product-block--price");if(!terms||!price||terms.parentElement===price)return;price.appendChild(terms)}function assemble(){
reviewLabel();
var context=coreContext();
if(!context){
removeDynamicEntry();
return{planner:true,hanging:"absent"}
}
styles();
keepSellingPointsBeforeBuy(context.meta,context.buy);movePaymentTerms(context);ensureDelivery(context);
var planner=ensurePlanner(context);
var hanging=ensureHanging(context);
return{planner:planner,hanging:hanging}
}
function init(){
reviewLabel();
if(!document.body.classList.contains("template-product")){
removeDynamicEntry();
document.addEventListener("shopify:section:load",removeDynamicEntry);
window.addEventListener("pageshow",removeDynamicEntry);
return
}
var context=coreContext();
if(!context){
removeDynamicEntry();
document.addEventListener("shopify:section:load",removeDynamicEntry);
window.addEventListener("pageshow",removeDynamicEntry);
return
}
styles();
var reviewObserver=new MutationObserver(reviewLabel);
reviewObserver.observe(document.body,{childList:true,subtree:true,characterData:true});
window.setTimeout(function(){reviewObserver.disconnect()},30000);
var attempts=0;
var timer=window.setInterval(function(){
attempts++;
var state=assemble();
if(state.planner&&state.hanging!=="pending")window.clearInterval(timer);
else if(attempts>=80){
var timedOutContext=coreContext();
if(timedOutContext)cleanOldSetup(timedOutContext,null);
window.clearInterval(timer)
}
},250);
assemble();
document.addEventListener("shopify:section:load",function(){window.setTimeout(assemble,0)});
window.addEventListener("pageshow",assemble)
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init()
})();